module.exports = __webpack_public_path__ + "img/account-circle-outline.491527f.svg";